<template>
  <div class="ride-cancel">
    <div class="modal ride-cancel-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal" />

      <div class="modal-card">
        <section v-if="showReasons" class="modal-card-body">
          <p class="subtitle is-4">{{ $t("ride.tell-us-cancel-reason") }} 🙏🏽</p>

          <div class="list-wrapper no-scrollbar">
            <div class="list has-text-left" style="margin-bottom: 10px">
              <span
                v-show="hasFare"
                class="list-item is-pointer"
                @click="cancel('fare-high')"
                v-ripple
              >
                {{ $t("cancel-reasons.fare-high") }}
              </span>
              <span
                v-for="r in reasons"
                :key="r"
                class="list-item is-pointer"
                :class="{ 'primary-bg': r === 'dont-cancel' }"
                @click="cancel(r)"
                v-ripple
              >
                {{ $t(`cancel-reasons.${r}`) }}
              </span>
            </div>
          </div>
        </section>
        <section v-else class="modal-card-body">
          <p class="subtitle is-4">
            {{ $t("ride.cancel-are-you-sure") }}
          </p>

          <div class="yes-no-wrapper">
            <span
              class="button is-danger is-rounded"
              @click="showReasons = true"
            >
              {{ $t("yes-cancel") }} </span
            >&nbsp;
            <span class="button is-link is-rounded" @click="closeModal">
              {{ $t("no") }}
            </span>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RideCancelModal",
  components: {},
  props: {
    t: Object,
  },
  data() {
    return {
      showReasons: false,
      reasons: [
        "driver-far",
        "no-driver",
        "changed-mind",
        "other",
        "dont-cancel",
      ],
    };
  },
  computed: {
    hasFare() {
      if (!this.t) return false;
      // actually should check if transaction has fare > 0
      return this.t.workflow_type_name !== "Private Tuk Tuk";
    },
  },
  methods: {
    closeModal() {
      this.showReasons = false; // reset
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    cancel(reason) {
      if (reason === "dont-cancel") {
        this.closeModal();
        return;
      }
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: {
            state: "cancelled_by_passenger",
            data: { cancel_reason: reason },
          },
        })
        .then(() => {
          this.updateTransactionsForCustomer(true);
          var youCancelled = this.$t("passenger.you-cancelled");
          var comeAgain = this.$t("passenger.come-again");
          this.$swal({
            html: `${youCancelled}<br>${comeAgain}`, //"Sorry you had to cancel...<br>Please come again!",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => this.goHome());
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
      // otherwise cancel
      setTimeout(() => this.closeModal(), 200);
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  width: 95vw;
  max-width: 500px;
  margin: 0 auto;
  border-radius: 25px;
}
.subtitle {
  margin-bottom: 12px;
}
.primary-bg {
  background-color: rgba(54, 213, 155, 0.675);
}
</style>